import { useCallback, useState } from 'react';

interface UseDropZoneConfig {
  onDragEnter?: () => void;
  onDragLeave?: () => void;
  disabled?: boolean;
}

export const useDropZone = (config?: UseDropZoneConfig) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = useCallback(
    (e: React.DragEvent) => {
      if (config?.disabled) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
    },
    [config?.disabled]
  );

  const handleDragEnter = useCallback(
    (e: React.DragEvent) => {
      if (config?.disabled) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(true);
      config?.onDragEnter?.();
    },
    [config?.disabled, config?.onDragEnter]
  );

  const handleDragLeave = useCallback(
    (e: React.DragEvent) => {
      if (config?.disabled) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
      config?.onDragLeave?.();
    },
    [config?.disabled, config?.onDragLeave]
  );

  return {
    isDragging,
    dragHandlers: {
      onDragOver: handleDragOver,
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave
    }
  };
};
